module.exports = __webpack_public_path__ + "img/cv2.84e1948c.png";